import styled from '@emotion/styled'
import { stripUnit } from 'polished'
import { css } from '@emotion/react'

export const Columns = styled.div(
  ({
    theme,
    numberOfChildren,
    cardStyled,
    leftAligned,
    layout,
    packageCardLayout,
    extraTopSpacingForLabel,
  }) => css`
    /* width is required when parent flex containers attempt to align items */
    width: 100%;
    grid-template-columns: repeat(
      auto-fit,
      minmax(${stripUnit(theme.breakpoints.xs) / 2}px, 1fr)
    );

    grid-gap: ${theme.spacing.lg};

    .gatsby-image-wrapper {
      overflow: unset !important;
    }

    > div {
      margin-bottom: ${theme.spacing.lg};

      > .svg-image {
        margin-bottom: ${theme.spacing.md};
      }

      ${layout === 'Image To Bottom' ||
      (theme?.components?.Column?.image === 'full' &&
        `
        .gatsby-image-wrapper {
          margin-bottom: 0 !important;
        }
      `)}
      ${layout === 'Image To Bottom' && // full width image doesn't need this because it has it's own padding
      theme?.components?.Column?.image !== 'full' &&
      `
        .content {
          padding-bottom: ${theme.spacing.md} !important;
        }
      `}
          &:last-of-type {
        margin-bottom: 0;
      }

      @media (min-width: ${theme.breakpoints.lg}) {
        ${extraTopSpacingForLabel &&
        `
        padding-top: 32px;
      `}
      }
    }

    @media (min-width: ${theme.breakpoints.lg}) {
      display: grid;

      > div {
        margin-bottom: 0;
      }

      ${numberOfChildren === 2 &&
      `
        .leshen-package-card {
          &:first-of-type {
            .wrapper {
              margin-left: auto;
              margin-right: 0;
            }
          }

          &:last-of-type {
            .wrapper {
              margin-left: 0;
              margin-right: auto;
            }
          }
        }
      `};
    }

    ${numberOfChildren > 4 && `grid-template-columns: repeat(3, 1fr)`};

    ${cardStyled &&
    `
      > div, .leshen-column-wrapper {
        color: ${theme.colors.dark.base.hex};
        box-shadow: ${theme.shadow} !important;
        background-color: ${theme.colors.white.base.hex};
      }
    `} // the anchor styles are to overwrite the theme link styles since the
              // columns don't have custom background colors yet. When they do, set these to base.readable
      ${!leftAligned &&
    `      
    > div, .leshen-column-wrapper {
        align-items: center;
        padding-top: ${
          theme?.components?.Column.image !== 'full' && theme.spacing.md
        };
      }
      
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        .svg-image {
          margin-left: auto;
          margin-right: auto;
        }
      }
    `}

      ${leftAligned &&
    theme?.components?.Column?.image !== 'full' &&
    `
        > div, .leshen-column-wrapper {
        img {
          margin: ${theme.spacing.md};
          margin-right: auto;
        }
      }
      .svg-image {
        svg {
        margin-left: 0;
        margin-right: auto;
        }
      }
    `} // leftAligned uses flexbox so specifically keeping these separate for now
      ${layout === 'Left Icon' &&
    leftAligned &&
    `
      > .leshen-column-wrapper {
        display: flex !important;
        flex-direction: row;
        gap: 16px;
      }

      .svg-image {
        align-items: flex-start;

        svg {
          display: inline-block;
          width: 64px;
          height: 64px;
        }
      }
    `}

      ${layout === 'Image To Bottom' &&
    `
      > .leshen-column-wrapper {
        display: flex !important;
        flex-direction: column-reverse;
        justify-content: flex-end;

        .svg-image, .gatsby-image-wrapper {
          margin-top: auto;
          margin-bottom: 0;
        }
      }
    `}

      ${layout === 'Image To Bottom' &&
    theme?.components?.Column?.image === 'full' &&
    cardStyled &&
    `
      > .leshen-column-wrapper {
        .gatsby-image-wrapper {
          margin-bottom: 0 !important;
          img {
            border-bottom-right-radius: ${theme.radius};
            border-bottom-left-radius: ${theme.radius};
          }
        }
      }
    `}

      ${layout !== 'Image To Bottom' &&
    theme?.components?.Column?.image === 'full' &&
    cardStyled &&
    `
      > .leshen-column-wrapper {
        .gatsby-image-wrapper {

          img {
            border-top-right-radius: ${theme.radius};
            border-top-left-radius: ${theme.radius};
          }
        }
      }
    `}

      ${packageCardLayout === 'Rows' &&
    `
        grid-template-columns: 1fr;

        .leshen-package-card:first-of-type .wrapper {
          margin-right: auto;
        }

        .leshen-package-card:last-of-type .wrapper {
          margin-left: auto;
        }
    `}
  `
)

export const Carousel = styled.div(
  ({ theme, cardStyled, leftAligned, layout, packageCardLayout }) => css`
    width: 100%;

    .leshen-column-wrapper {
      margin-left: 16px;
      margin-right: 16px;
    }

    .leshen-carousel {
      padding-left: 0;
      padding-right: 0;

      > div {
        overflow: unset;
        overflow-x: clip;
      }
    }

    .svg-image {
      margin-bottom: ${theme.spacing.md};
    }

    ${!leftAligned &&
    `
      > div, .leshen-column-wrapper {
        padding: ${theme.spacing.md};
      }
      .content * {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .content {
        .svg-image {
          svg {
            margin-left: auto !important;
            margin-right: auto;
          }
        }
      }
    `}

    ${leftAligned &&
    `
      .leshen-column-wrapper {
        text-align: left;
      }
      .svg-image {
        svg {
        margin-left: 0;
        margin-right: auto;
        }
      }
    `}

      ${cardStyled &&
    `
      .leshen-column-wrapper {
        color: ${theme.colors.dark.base.hex};
        box-shadow: ${theme.shadow} !important;
        background-color: ${theme.colors.white.base.hex};
      }
    `} // leftAligned uses flexbox so specifically keeping these separate for now
      ${layout === 'Left Icon' &&
    leftAligned &&
    `
      .leshen-column-wrapper {
        display: flex !important;
        flex-direction: row;
        gap: 16px;
        img {
          margin-left: 0px;
          margin-right: auto;
        }
      }

      .svg-image {
        align-items: flex-start;

        svg {
          display: inline-block;
          width: 64px;
          height: 64px;
        }
      }
    `}

      ${layout === 'Image To Bottom' &&
    `
      .leshen-column-wrapper {
        display: flex !important;
        flex-direction: column-reverse;
        justify-content: flex-end;

        .svg-image, .gatsby-image-wrapper {
          margin-top: auto;
        }
      }
    `}

      ${layout === 'Image To Bottom' &&
    theme?.components?.Column?.image === 'full' &&
    cardStyled &&
    `
      .leshen-column-wrapper {
        .gatsby-image-wrapper {
          margin-bottom: 0 !important;
          img {
            border-bottom-right-radius: ${theme.radius};
            border-bottom-left-radius: ${theme.radius};
          }
        }
      }
    `}

      ${layout !== 'Image To Bottom' &&
    theme?.components?.Column?.image === 'full' &&
    cardStyled &&
    `
      .leshen-column-wrapper {
        .gatsby-image-wrapper {

          img {
            border-top-right-radius: ${theme.radius};
            border-top-left-radius: ${theme.radius};
          }
        }
      }
    `}

      ${packageCardLayout !== 'Rows' &&
    theme?.components?.Column?.image === 'full' &&
    cardStyled &&
    `
      .leshen-column-wrapper {
        .gatsby-image-wrapper {

          img {
            border-top-right-radius: ${theme.radius};
            border-top-left-radius: ${theme.radius};
          }
        }
      }
    `}
  `
)
